import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

import { AlertIconContainer, IconStyled } from './TrlFieldAlertIcon.styles';

export const TrlFieldAlertIcon = ({ showIcon, alertType }) => (
  <AlertIconContainer showIcon={showIcon}>
    <IconStyled icon={faCircleExclamation} alertType={alertType} />
  </AlertIconContainer>
);

TrlFieldAlertIcon.propTypes = {
  showIcon: PropTypes.bool,
  alertType: PropTypes.oneOf(['error', 'warning']).isRequired,
};
